import type { ProjectResource } from "@octopusdeploy/octopus-server-client";
import React from "react";
import { CreateOrEditDeploymentFreeze } from "~/components/DeploymentFreezes/CreateOrEditDeploymentFreeze";
interface ProjectDeploymentFreezePageProps {
    deploymentFreezeId: string;
    project: ProjectResource;
    spaceId: string;
}
export function ProjectDeploymentFreezePage({ deploymentFreezeId, project }: ProjectDeploymentFreezePageProps) {
    return <CreateOrEditDeploymentFreeze create={false} deploymentFreezeId={deploymentFreezeId} project={project}/>;
}
